import { render, staticRenderFns } from "./BhUserPatientWithSelectTableRow.vue?vue&type=template&id=816b437c&"
import script from "./BhUserPatientWithSelectTableRow.vue?vue&type=script&lang=js&"
export * from "./BhUserPatientWithSelectTableRow.vue?vue&type=script&lang=js&"
import style0 from "./BhUserPatientWithSelectTableRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports